import { TypeaheadProps } from '@procore/core-react/dist/_typedoc/Typeahead/Typeahead.types.json';
import * as React from 'react';
export default {
  TypeaheadProps,
  React
};